var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticClass:"form-control form-control-lg",domProps:{"value":_vm.value},on:{"input":_vm.input}})])}
var staticRenderFns = []

export { render, staticRenderFns }